import { SelectionModel } from '@angular/cdk/collections';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import {
  ScSelectionType,
  ScCrudRules,
  ScTableActionSelection,
  ScTableAction,
  ScTableColumn,
  ScTableViewConfig
} from '../../../models/table.model';
import { ColumnNamePipe } from './pipes/column-name.pipe';

@Component({
  selector: 'sc-material-table',
  styleUrls: ['sc-material-table.component.scss'],
  templateUrl: 'sc-material-table.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ScMaterialTableComponent implements OnInit {
  @ViewChild(MatSort) sort: MatSort;
  @Input() activeSort: string;
  @Input() selectionType: ScSelectionType;
  @Input() summary: boolean;
  @Input() sortDirection: string;
  @Input() rules: ScCrudRules;
  @Input() datasource: MatTableDataSource<any>;

  @Output() actionSelection: EventEmitter<ScTableActionSelection> = new EventEmitter();

  @Output() sortChange: EventEmitter<{
    active: string;
    direction: string;
  }> = new EventEmitter();

  @Output() fileViewer: EventEmitter<string> = new EventEmitter();

  public selection = new SelectionModel<any>(true, []);
  public displayedColumns = [];
  public TableAction = ScTableAction;
  public activeRow: any;
  public activeCell: ScTableColumn;

  private _tableConfig: ScTableViewConfig;
  private _selected: any[] = [];
  private _pageSize = 0;

  constructor(private _cd: ChangeDetectorRef, private _columnName: ColumnNamePipe) {}
  @Input() set tableConfig(tableConfig: ScTableViewConfig) {
    if (tableConfig) {
      this._tableConfig = tableConfig;
      const { columns } = tableConfig;
      this.displayedColumns = columns.map(c => this._columnName.transform(c));
    }
  }

  get tableConfig() {
    return this._tableConfig;
  }

  @Input() set selected(selected: any[]) {
    if (selected) {
      this._selected = selected;
      this.selected.forEach(row => this.selection.select(row));
    }
  }

  get selected() {
    return this._selected;
  }

  @Input() set pageSize(size: number) {
    this._pageSize = size || 0;
  }

  get pageSize() {
    return this._pageSize;
  }

  public ngOnInit(): void {}

  public trackByIndex = (index: number): number => index;

  public onSelect(row: any) {
    this.activeRow = row;
    this.selected = [row];
    this._cd.markForCheck();
    this.actionSelection.emit({
      type: ScTableAction.Select,
      data: row
    });
  }

  public sortData(event) {
    this.sortChange.emit(event);
  }

  public selectCell(cell: ScTableColumn) {
    if (cell.type === 'action' || cell.prop === 'action') {
      return;
    }
    this.activeCell = cell;
    this.actionSelection.emit({
      type: ScTableAction.ColSelect,
      data: cell.prop
    });
  }

  public isCellSelection() {
    return this.selectionType && this.selectionType === 'cell';
  }

  public isRowSelection() {
    return this.selectionType && this.selectionType === 'single';
  }

  public isSelected(row: any) {
    const selected = this.selected && this.selected.length ? this.selected[0] : null;

    if (selected) {
      return selected === row || selected.id === row.id;
    }
    return this.activeRow === row;
  }

  public isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.datasource.data.length;
    return numSelected === numRows;
  }

  public masterToggle() {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    this.isAllSelected() ? this.selection.clear() : this.datasource.data.forEach(row => this.selection.select(row));
  }

  public checkChange(row: any): void {
    this.selection.toggle(row);
    this.actionSelection.emit({
      type: ScTableAction.Select,
      data: this.selection.selected
    });
    this._cd.markForCheck();
  }
}
